import { Controller } from "@hotwired/stimulus"
import { connectStreamSource, disconnectStreamSource } from "@hotwired/turbo"

export default class extends Controller {
  static values = {
    updateInterval: { type: Number, default: 10000 } // Fallback polling every 10s
  }

  connect() {
    this.subscribeToChannel()
    
    // Set up fallback polling in case WebSocket fails
    this.startPolling()
  }

  disconnect() {
    this.unsubscribeFromChannel()
    this.stopPolling()
  }

  subscribeToChannel() {
    // Create consumer if not exists
    if (!this.consumer) {
      this.consumer = this.createConsumer()
    }

    // Subscribe to admin channel
    this.subscription = this.consumer.subscriptions.create("AdminChannel", {
      connected: () => {
        this.stopPolling() // Stop polling when WebSocket is active
      },

      disconnected: () => {
        this.startPolling() // Resume polling on disconnect
      },

      received: (data) => {
        if (data.html) {
          // Turbo Stream format
          Turbo.renderStreamMessage(data.html)
        }
        // Note: refresh_frame actions are handled silently to prevent reload loops
      }
    })
  }

  unsubscribeFromChannel() {
    if (this.subscription) {
      this.subscription.unsubscribe()
      this.subscription = null
    }
  }

  createConsumer() {
    // Use Rails' ActionCable consumer
    const cable = window.App?.cable || require("@rails/actioncable").createConsumer()
    return cable
  }

  startPolling() {
    if (this.pollingInterval) return
    
    this.pollingInterval = setInterval(() => {
      this.refreshFrames()
    }, this.updateIntervalValue)
  }

  stopPolling() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval)
      this.pollingInterval = null
    }
  }

  refreshFrames() {
    // Reload the current page while preserving the tab parameter
    const url = new URL(window.location.href)
    const tabParam = url.searchParams.get('tab')
    const hashParam = url.hash.replace('#', '')
    const currentTab = tabParam || hashParam || 'dashboard'
    
    // Reload with the current tab
    window.location.href = `/admin?tab=${currentTab}`
  }
}

